import { Center, HStack, Link, Text } from '@chakra-ui/react';
import { isNil, range, reject } from 'ramda';
import React from 'react';
import { ChevronLeft, ChevronRight } from '../../icons';
const Number = (props)=>{
    const { href , page , activePage  } = props;
    return /*#__PURE__*/ React.createElement(Center, {
        as: Link,
        href: href,
        ...page === activePage && {
            border: '1px solid var(--chakra-colors-stroke-interactive)'
        },
        borderRadius: "4px",
        h: "30px",
        w: "30px"
    }, /*#__PURE__*/ React.createElement(Text, {
        color: "text.primary",
        textStyle: "mBold"
    }, page));
};
export const Pagination = (props)=>{
    const { activePage , pagesCount , getPageUrl , link , ...stackProps } = props;
    const pages = pagesCount > 5 ? reject(isNil, [
        1,
        activePage > 3 ? '...' : null,
        activePage - 1 > 1 && activePage - 1 < pagesCount ? activePage - 1 : null,
        activePage !== 1 && activePage < pagesCount ? activePage : null,
        activePage + 1 !== pagesCount && activePage + 1 < pagesCount ? activePage + 1 : null,
        activePage < pagesCount - 2 ? '...' : null,
        pagesCount
    ]) : range(1, pagesCount + 1);
    const hiddenPages = pages.reduce((acc, page, index)=>{
        if (page === '...') {
            return [
                ...acc,
                ...range(pages[index - 1] + 1, pages[index + 1])
            ];
        }
        return acc;
    }, []);
    const previousPageUrl = getPageUrl(activePage - 1);
    const nextPageUrl = getPageUrl(activePage + 1);
    return /*#__PURE__*/ React.createElement(HStack, {
        alignContent: "center",
        display: "flex",
        spacing: 1,
        ...stackProps
    }, activePage !== 1 && /*#__PURE__*/ React.cloneElement(link, {
        href: previousPageUrl,
        key: 'previousPage'
    }, /*#__PURE__*/ React.createElement(Link, {
        "aria-label": "Previous Page",
        rel: "prev"
    }, /*#__PURE__*/ React.createElement(ChevronLeft, {
        color: "var(--chakra-colors-link-link)",
        size: 24
    }))), pages.map((page, index)=>{
        const isPage = typeof page === 'number';
        const href = isPage && getPageUrl(page);
        return isPage ? /*#__PURE__*/ React.cloneElement(link, {
            href,
            key: page
        }, /*#__PURE__*/ React.createElement(Number, {
            activePage: activePage,
            page: page
        })) : /*#__PURE__*/ React.createElement(Center, {
            h: "30px",
            key: `${page}-${index}`,
            w: "30px"
        }, /*#__PURE__*/ React.createElement(Text, {
            color: "text.primary",
            textStyle: "mBold"
        }, page));
    }), activePage < pagesCount && /*#__PURE__*/ React.cloneElement(link, {
        href: nextPageUrl,
        key: 'nextPage'
    }, /*#__PURE__*/ React.createElement(Link, {
        "aria-label": "Next Page",
        rel: "next"
    }, /*#__PURE__*/ React.createElement(ChevronRight, {
        color: "var(--chakra-colors-link-link)",
        size: 24
    }))), hiddenPages.map((hiddenPageNumber)=>{
        const href = getPageUrl(hiddenPageNumber);
        const useHref = typeof href === 'string';
        return /*#__PURE__*/ React.cloneElement(link, {
            href,
            key: hiddenPageNumber
        }, // If href is an object, the Next.js Link component will be providing the href
        /*#__PURE__*/ React.createElement("a", {
            href: useHref ? href : '/',
            key: hiddenPageNumber,
            style: {
                display: 'none'
            }
        }, hiddenPageNumber));
    }));
};

//# sourceMappingURL=pagination.js.map